import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDate } from "../../../../../../formatDate";
import axios from "axios";
import { useAppContext } from "../../../../../../../AppContext";

function ViewClient() {
  const { user, chimeraserv, components } = useAppContext();
  const props = { user, chimeraserv, components };
  const { id } = useParams();
  const location = useLocation();
  const basePath = location.pathname.split("/").slice(0, 3).join("/");
  const [title] = useState("Client Info | Chimera Solutions | Insights");
  const [data, setData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [load, setLoad] = useState(false);

  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const userStatusChange = async (data, key) => {
    const updatedStatus = data.status === 1 ? 0 : 1;
    const updatedData = { ...data, status: updatedStatus };
    //update UI
    setUserData((prev) => ({
      ...prev,
      users: prev.users.map((item) =>
        item._id === data._id ? { ...item, status: updatedStatus } : item
      ),
    }));

    try {
      await axios.put(props.chimeraserv.urlPost + "/user/update", updatedData, {
        headers: {
          Authorization: props.user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      // Optionally refetch or handle success
    } catch (error) {
      setUserData((prev) => ({
        ...prev,
        users: prev.users.map((item) =>
          item._id === data._id ? { ...item, status: user.status } : item
        ),
      }));
    }
  };
  const outletChange = async (groupData, group, brand, chain, groupIndex) => {
    // Create a copy of the current data to avoid mutating state directly
    const updatedData = [...data];
    const currentGroupIndex = updatedData.findIndex(
      (g) => g._id === groupData._id
    );

    if (currentGroupIndex !== -1) {
      // Find the brand index
      const brandIndex = updatedData[currentGroupIndex].brands.findIndex(
        (b) => b.braKey === brand.braKey
      );

      if (brandIndex !== -1) {
        // Find the chain index
        const chainIndex = updatedData[currentGroupIndex].brands[
          brandIndex
        ].chains.findIndex((c) => c.chaKey === chain.chaKey);

        if (chainIndex !== -1) {
          // Toggle the chain status in local state first
          updatedData[currentGroupIndex].brands[brandIndex].chains[
            chainIndex
          ].status =
            updatedData[currentGroupIndex].brands[brandIndex].chains[chainIndex]
              .status === 1
              ? 0
              : 1;

          // Update local state immediately for better UX
          setData(updatedData);

          try {
            // Send update to server
            await axios.put(
              props.chimeraserv.urlPost + "/group/update",
              updatedData[currentGroupIndex],
              { headers }
            );
          } catch (error) {
            console.error("Error updating outlet:", error);
            // Revert the change if API call fails
            updatedData[currentGroupIndex].brands[brandIndex].chains[
              chainIndex
            ].status =
              updatedData[currentGroupIndex].brands[brandIndex].chains[
                chainIndex
              ].status === 1
                ? 0
                : 1;
            setData(updatedData);
          }
        }
      }
    }
  };

  const brandChange = async (group, brand) => {
    // Create a copy of the current data to avoid mutating state directly
    const updatedData = [...data];
    const groupIndex = updatedData.findIndex((g) => g._id === group._id);

    if (groupIndex !== -1) {
      const brandIndex = updatedData[groupIndex].brands.findIndex(
        (b) => b.braKey === brand.braKey
      );

      if (brandIndex !== -1) {
        // Toggle the brand status in local state first
        updatedData[groupIndex].brands[brandIndex].status =
          updatedData[groupIndex].brands[brandIndex].status === 1 ? 0 : 1;

        // Update local state immediately for better UX
        setData(updatedData);

        try {
          // Send update to server
          await axios.put(
            props.chimeraserv.urlPost + "/group/update",
            updatedData[groupIndex],
            { headers }
          );
        } catch (error) {
          console.error("Error updating brand:", error);
          // Revert the change if API call fails
          updatedData[groupIndex].brands[brandIndex].status =
            updatedData[groupIndex].brands[brandIndex].status === 1 ? 0 : 1;
          setData(updatedData);
        }
      }
    }
  };
  const valueChange = async (dataObj, key) => {
    dataObj.status = dataObj.status === 1 ? 0 : 1;

    try {
      await axios.put(props.chimeraserv.urlPost + "/group/update", dataObj, {
        headers,
      });
      setLoad(false);

      setData([dataObj]);
      setLoad(true);
    } catch (error) {
      setLoad(false);
    }
  };
  const loadUserData = useCallback(
    async (groupId) => {
      if (!groupId) return;

      try {
        const response = await axios.get(
          props.chimeraserv.urlGet + "/group_users/" + groupId,
          { headers }
        );

        setUserData(response.data);
      } catch (error) {
        console.error("Error loading user data:", error);
        setUserData(null);
      }
    },
    [props.chimeraserv.urlGet, headers.Authorization]
  );

  const loadData = useCallback(async () => {
    try {
      const response = await axios.get(
        props.chimeraserv.urlGet + "/group/" + id,
        { headers }
      );

      const filteredData = response.data.filter((d) => d._id === id);
      setData(filteredData);
      setLoad(true);

      // Call loadUserData with the group ID after data is loaded
      if (filteredData.length > 0) {
        loadUserData(filteredData[0]._id);
      }
    } catch (error) {
      console.error("Error loading group data:", error);
      setData([]);
      setLoad(true);
    }
  }, [props.chimeraserv.urlGet, id, headers.Authorization, loadUserData]);

  // useEffect(() => {
  //   if (data.length > 0 && data[0]._id) {
  //     loadUserData(data[0]._id);
  //   }
  // }, [data, loadUserData]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [loadData]);

  const Loader =
    props.components && props.components.setting && props.components.setting[1]
      ? props.components.setting[1].component
      : () => <div>Loading...</div>;

  return (
    <div className={["custForm", "custView"].join(" ")}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={["viewTitle"]}>Client Info</div>
      {!load ? (
        <Loader />
      ) : (
        <div>
          <div className={["form", "fullWidth"].join(" ")}>
            {data.map((data, key) => (
              <div key={key}>
                <div className={["form-group"]}>
                  <label>Client Name</label>
                  <div className={["field", "value"].join("_")}>
                    {data.name}
                  </div>
                </div>
                <div className={["form-group"]}>
                  <label>Created On</label>
                  <div className={["field", "value"].join("_")}>
                    {formatDate.longShort(data.created)}
                  </div>
                </div>
                <div className={["form-group"]}>
                  <label>Modified</label>
                  <div className={["field", "value"].join("_")}>
                    {formatDate.longShort(data.modified)}
                  </div>
                </div>
                <div className={["form-group"]}>
                  <label>Account Expiration</label>
                  <div className={["field", "value"].join("_")}>
                    {formatDate.longShort(data.accntExp)}
                  </div>
                </div>
                <div className={["form-group"]}>
                  <label>Status</label>
                  <div className={["field", "value"].join("_")}>
                    {data.status ? "Active" : "Inactive"}
                  </div>
                </div>
                {props.user.data.level === 0 ? (
                  <div className={["actions", "actionsAdmin"].join(" ")}>
                    <Link
                      to={basePath + "/main/edit/" + data._id}
                      className={["btn btn-primary"]}
                    >
                      Edit
                    </Link>
                    <button
                      type={"button"}
                      // onClick={() => valueChange(data, key)}
                      className={["btn", "btn-primary", "disable"].join(" ")}
                    >
                      {data.status ? "Disable" : "Enable"}
                    </button>
                  </div>
                ) : (
                  <div />
                )}
              </div>
            ))}
          </div>
          <div className="form fullWidth">
            {data.map((data, key) => (
              <div key={key}>
                <div className="form-group">
                  <label>Group Key</label>
                  <div className="field_value">{data.grpKey}</div>
                </div>
                <div className="form-group">
                  <label>Brands</label>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Brand Key</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.brands.map((brand, idx) => (
                        <tr key={idx}>
                          <td>{brand.name}</td>
                          <td>{brand.braKey}</td>
                          <td className="actions">
                            {props.user.data.level === 0 ? (
                              <div className="actionsAdmin">
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    id={brand.braKey}
                                    checked={!!brand.status}
                                    onChange={() => brandChange(data, brand)}
                                  />
                                  <span className="slider"></span>
                                </label>
                                <Link
                                  to={basePath + "/brand/edit/" + brand.braKey}
                                >
                                  <FontAwesomeIcon
                                    className={["icon"].join(" ")}
                                    icon={["fas", "cog"]}
                                  />{" "}
                                  Edit
                                </Link>
                              </div>
                            ) : (
                              <div />
                            )}
                            <Link to={basePath + "/brand/view/" + brand.braKey}>
                              <FontAwesomeIcon
                                className={["icon"].join(" ")}
                                icon={["fas", "eye"]}
                              />{" "}
                              View
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className={["form-group"]}>
                  <label>Outlets</label>
                  <table className="table table-striped defaultTable">
                    <thead>
                      <tr>
                        <th>Brand</th>
                        <th>Outlet</th>
                        <th>Status</th>
                        <th>Chain Key</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[].concat
                        .apply(
                          [],
                          data.brands.map((brand, braKey) =>
                            brand.chains.map((chain) => ({
                              data: data,
                              group: {
                                index: key,
                                grpKey: data.grpKey,
                                _id: data._id,
                                name: data.name,
                              },
                              brand: {
                                index: braKey,
                                braKey: brand.braKey,
                                name: brand.name,
                              },
                              ...chain,
                            }))
                          )
                        )
                        .map((chain, idx) => (
                          <tr key={idx}>
                            <td>{chain.brand.name}</td>
                            <td>{chain.name}</td>
                            <td>
                              <div className={"name"}>
                                <div
                                  className={[
                                    "status",
                                    chain.info.status ? "" : "offline",
                                  ].join(" ")}
                                />
                                {chain.info.status ? "Online" : "Offline"}
                              </div>
                            </td>
                            <td>{chain.chaKey}</td>
                            <td className="actions">
                              {props.user.data.level === 0 ? (
                                <div className="actions actionsAdmin">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      id={chain.braKey}
                                      checked={!!chain.status}
                                      onChange={() =>
                                        outletChange(
                                          chain.data,
                                          chain.group,
                                          chain.brand,
                                          chain,
                                          key
                                        )
                                      }
                                    />
                                    <span className="slider"></span>
                                  </label>
                                  <Link
                                    to={
                                      basePath + "/outlet/edit/" + chain.chaKey
                                    }
                                  >
                                    <FontAwesomeIcon
                                      className={["icon"].join(" ")}
                                      icon={["fas", "cog"]}
                                    />{" "}
                                    Edit
                                  </Link>
                                </div>
                              ) : (
                                <div />
                              )}
                              <Link
                                to={basePath + "/outlet/view/" + chain.chaKey}
                              >
                                <FontAwesomeIcon
                                  className={["icon"].join(" ")}
                                  icon={["fas", "eye"]}
                                />{" "}
                                View
                              </Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div className="form-group">
                  <label>Users</label>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Last Login</th>
                        <th>Type</th>
                        <th>Brand</th>
                        <th>Outlets</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData ? (
                        userData.users.map((user, idx) => {
                          let brandDisplay = [];
                          let outletsDisplay = [];
                          if (user.level && data?.brands) {
                            data.brands.forEach((brand) => {
                              // Count outlets (chains) where user's level is included
                              const matchingChains = brand.chains.filter(
                                (chain) =>
                                  Array.isArray(chain.levels) &&
                                  // chain.levels.some(
                                  //   (levelObj) =>
                                  //     String(levelObj.id) === String(user.level)
                                  // )
                                  chain.levels.includes(user.level)
                              );
                              if (matchingChains.length > 0) {
                                brandDisplay.push(
                                  `${brand.name} (${matchingChains.length})`
                                );
                                outletsDisplay.push(
                                  matchingChains
                                    .map((chain) => chain.name)
                                    .join(", ")
                                );
                              }
                            });
                          }
                          return (
                            <tr key={idx}>
                              <td>{user.username}</td>
                              <td>
                                {user.lastLoginTime
                                  ? formatDate.long(user.lastLoginTime / 1000)
                                  : "No Last Login"}
                              </td>
                              <td>{user.type}</td>

                              <td>
                                {brandDisplay.length > 0
                                  ? brandDisplay.join(", ")
                                  : "No Brands"}
                              </td>
                              <td>
                                {outletsDisplay.length > 0
                                  ? outletsDisplay.join(", ")
                                  : "No Outlets"}
                              </td>

                              <td className="actions">
                                {props.user.data.level === 0 ? (
                                  <div className="actionsAdmin">
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        id={user._id}
                                        checked={user.status}
                                        onChange={() => userStatusChange(user)}
                                      />
                                      <span className="slider"></span>
                                    </label>
                                    <Link
                                      to={
                                        location.pathname
                                          .split("/")
                                          .slice(0, 2)
                                          .join("/") +
                                        "/user/edit/" +
                                        user._id
                                      }
                                    >
                                      <FontAwesomeIcon
                                        className={["icon"].join(" ")}
                                        icon={["fas", "cog"]}
                                      />{" "}
                                      Edit
                                    </Link>
                                  </div>
                                ) : (
                                  <div />
                                )}
                                <Link
                                  to={
                                    location.pathname
                                      .split("/")
                                      .slice(0, 2)
                                      .join("/") +
                                    "/user/view/" +
                                    user._id
                                  }
                                >
                                  <FontAwesomeIcon
                                    className={["icon"].join(" ")}
                                    icon={["fas", "eye"]}
                                  />{" "}
                                  View
                                </Link>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            {userData === null
                              ? "Loading users..."
                              : "No users found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewClient;
